/* eslint-disable vue/multi-word-component-names */

<template>
  <header class="header" id="top">
    <ul class="header__nav-container">
      <li class="header__mobile-link-container burger-sm">
        <div class="header__mobile-link" @click="toggleNav">
          <img
            src="../assets/site-icons/burger-icon.svg"
            alt="grey burger icon for mobile navigation"
            class="header__mobile-burger"
            aria-role="menu-toggle"
          >
        </div>
      </li>
      <li class="header__mobile-link-container logo-sm">
        <router-link to="/" exact class="header__mobile-link">
          <img src="../assets/site-icons/logo-sm.svg" alt="mjccreative" class="header__mobile-logo">
        </router-link>
      </li>
      <li
        class="header__nav-link-container header__nav-link-container--start email header__nav-link-container--sm-pad"
      >
        email:
        <a href="mailto:hello@mjccreative.me" class="header__nav-link">hello@mjccreative.me</a>
      </li>
      <li class="header__nav-link-container linkedin header__nav-link-container--sm-pad">
        <a
          href="https://uk.linkedin.com/in/mjccreative"
          target="_blank"
          class="header__nav-link"
        >linkedin</a>
      </li>
      <li class="header__nav-link-container cv header__nav-link-container--sm-pad">
        <!-- <router-link to="/cv" exact class="header__nav-link">
          view c<span class="header__hidden-text">urriculum</span>v<span class="header__hidden-text">itae</span>
        </router-link> -->
        <router-link to="/about" exact class="header__nav-link">
          about me
        </router-link>
      </li>
      <li class="header__nav-link-container header__search__icon">
        <div class="header__search-link" @click="toggleSearch">
          <img
            src="../assets/site-icons/search-icon.svg"
            alt="grey magnifying glass icon for search"
            class="header__search-icon"
          >
        </div>
      </li>
      <li class="header__nav-link-container header__search" id="search">
        <input
          type="search"
          placeholder="search_"
          class="header__search-input"
          v-model="searchTerm"
          @keyup="search"
          aria-label="search"
        >
      </li>
    </ul>
  </header>
</template>

<script type="text/javascript">
export default {
  data() {
    return {
      searchTerm: ""
    };
  },
  methods: {
    search: function() {
      this.$router.push({
        path: "/collection/" + this.searchTerm.toLowerCase()
      });
    },
    toggleNav: function() {
      var mobileNav = document.getElementById("site__wrapper");
      mobileNav.classList.toggle("active");
    },
    toggleSearch: function() {
      var mobileSearch = document.getElementById("search");
      mobileSearch.classList.toggle("active");
    }
  }
};
</script>

<style lang="scss" scoped>
@use "../assets/scss/_siteVariables";

.header {
  //mobile styles
  @media only screen and (max-width: 1000px) {
    // position: sticky;
    // top: 0;
    background: var(--white);
    // z-index: 1;
    margin-bottom: 15px;
  }
  @media only screen and (min-width: 1000px) {
    &__mobile-link-container {
      display: none;
    }
  }
  &__mobile-burger {
    width: 28px;
    height: 21px;
  }
  &__hidden-text {
    display: none;
    @media only screen and (min-width: 1000px) {
      display: inline-block;
      margin-right: 5px;
    }
  }
  &__mobile-logo {
    width: 45px;
    height: 45px;
  }
  //controls nav container
  &__nav-container {
    display: flex;
    margin: 0;
    padding: 0;
    list-style-type: none;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
  }
  //control nav links
  &__nav-link-container {
    font-size: 14px;
    padding: 24px 0;
    &--start {
      .header__nav-link {
        color: var(--darkest-grey);
      }
    }
    @media only screen and (max-width: 1000px) {
      &--sm-pad {
        padding: 12px 0;
      }
    }
    @media only screen and (min-width: 1000px) {
      &--start {
        margin-right: auto;
      }
    }
  }
  &__nav-link {
    color: var(--mid-grey);
    text-decoration: none;
    @media only screen and (min-width: 1000px) {
      padding-right: 30px;
    }
    &:hover {
      color: var(--accent);
      text-decoration: underline;
      .header__hidden-text {
        text-decoration: underline;
      }
    }
  }
  //order styles for mobile and sizing
  .burger-sm {
    order: 1;
    flex: 0 0 33.33333%;
  }
  .logo-sm {
    order: 2;
    text-align: center;
    flex: 0 0 33.33333%;
  }
  .header__search__icon {
    order: 3;
    flex: 0 0 33.33333%;
    display: flex;
    justify-content: flex-end;
    @media only screen and (min-width: 1000px) {
      flex: 0 0 auto;
      order: 0;
    }
  }
  .header__search {
    order: 4;
    flex: 0 0 111%;
    padding: 0;
    @media only screen and (min-width: 1000px) {
      flex: 0 0 auto;
    }
    &-input {
      padding: 9px 15px;
      border: 1px solid var(--light-grey);
      border-right: none;
      border-left: none;
      border-radius: 0px;
      width: 100%;
      background: var(--lightest-grey);
      // background: red;
      font-size: 16px;
      -webkit-appearance: none;
      -moz-appearance: none;
      appearance: none;
      @media only screen and (min-width: 1000px) {
        background: transparent;
        border: none;
        width: 60px;
        padding: 0;
        font-size: 14px;
      }
    }
  }
  #search {
    height: 0;
    opacity: 0;
    -webkit-transition: all 0.4s;
    -moz-transition: all 0.4s;
    transition: all 0.4s;
    overflow: hidden;
    @media only screen and (min-width: 1000px) {
      opacity: 1;
      height: auto;
    }
    &.active {
      opacity: 1;
      height: 35px;
      margin-bottom: 1px;
      margin-left: -15px;
      margin-right: -15px;
      overflow: visible;
      @media only screen and (min-width: 1000px) {
        margin: 0;
        height: auto;
    }
    }
  }
  .linkedin {
    order: 5;
  }
  .email {
    order: 6;
    position: relative;
    @media only screen and (max-width: 1000px) {
      &:before {
        content: "";
        position: absolute;
        width: 200vw;
        border-top: 1px solid var(--light-grey);
        left: -100vw;
        right: 0;
        top: 0;
      }
      &:after {
        content: "";
        position: absolute;
        width: 200vw;
        border-top: 1px solid var(--light-grey);
        left: -100vw;
        right: 0;
        bottom: 0;
      }
    }
  }
  .cv {
    order: 7;
  }

  // search styles for mobile
  &__search-link {
    display: block;
  }
  &__search {
    display: flex;
    align-items: center;
    font-size: 14px;
    &-icon {
      width: 16px;
      height: 17px;
      display: block;
    }
    &-input {
      border: none;
      color: var(--black);
      &:focus {
        color: var(--accent);
        outline: none;
      }
    }
  }
  // search styles for desktop
  @media only screen and (min-width: 1000px) {
    &__nav-container {
      justify-content: flex-end;
    }
    &__search {
      &-icon {
        margin-right: 5px;
      }
      &-input {
        width: 60px;
        -webkit-transition: all 0.5s;
        -moz-transition: all 0.5s;
        transition: all 0.5s;
        &:focus {
          width: 200px;
        }
      }
    }
    //desktop ordering
    .burger-sm {
      order: 0;
    }
    .logo-sm {
      order: 0;
    }
    .header__search {
      order: 0;
    }
    .linkedin {
      order: 0;
    }
    .email {
      order: 0;
    }
    .cv {
      order: 0;
    }
  }
}
</style>
